import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch, setStoredJwt } from '../lib/api';

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (password.length < 8) return setErr('Password must be at least 8 characters.');
    if (password !== confirm) return setErr('Passwords do not match.');
    setBusy(true);
    try {
      const res = await apiFetch('/api/auth/reset-password', { method: 'POST', body: { token, password } });
      setStoredJwt(res.access_token);
      setDone(true);
      setTimeout(() => { window.location.href = '/'; }, 1800);
    } catch (ex) {
      setErr(ex.message || 'Could not reset password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center p-4" data-testid="reset-password-page">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center"><span className="text-white font-bold text-sm">C</span></div>
          <span className="text-xl font-bold text-gray-900">Culinera</span>
        </Link>

        {!token ? (
          <div data-testid="reset-invalid">
            <h1 className="text-xl font-bold text-gray-900 mb-2">Invalid reset link</h1>
            <p className="text-sm text-gray-600">This link is missing its token. Please request a new password reset from the sign-in screen.</p>
            <Link to="/" className="inline-block mt-4 text-teal-600 font-semibold hover:underline">← Back home</Link>
          </div>
        ) : done ? (
          <div data-testid="reset-success" className="text-center py-4">
            <div className="text-4xl mb-3">✅</div>
            <h1 className="text-xl font-bold text-gray-900 mb-1">Password updated</h1>
            <p className="text-sm text-gray-600">You're now signed in. Taking you to Culinera…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 mb-1">Choose a new password</h1>
              <p className="text-sm text-gray-500">Enter a new password for your account.</p>
            </div>
            <input data-testid="reset-password-input" type="password" required minLength={8} placeholder="New password (min 8 chars)" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500" />
            <input data-testid="reset-confirm-input" type="password" required minLength={8} placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500" />
            {err && <div data-testid="reset-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2">{err}</div>}
            <button data-testid="reset-submit" type="submit" disabled={busy} className="w-full bg-teal-600 text-white px-4 py-3 rounded-lg font-semibold hover:bg-teal-700 disabled:opacity-50 transition-colors">{busy ? 'Updating…' : 'Update password'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
